import GLightbox from 'glightbox';

/**
 * Галерея фото номера (сторінка single-room) на GLightbox.
 *
 * Ініціалізуємо лише якщо на сторінці є посилання галереї — щоб не тягнути
 * лайтбокс на сторінках без неї. Групування — за data-gallery="room-{id}",
 * тож стрілки гортають фото саме цього номера.
 */
export default function roomGallery() {
	const items = document.querySelectorAll('.single-room__gallery .glightbox');
	if (!items.length) return;

	GLightbox({
		selector: '.single-room__gallery .glightbox',
		touchNavigation: true,
		loop: true,
	});
}
